// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260205/js/" + chunkId + "." + {"44":"d368b8ee","225":"c3a5fe91","481":"e815c4be","486":"f7ef07e2","770":"ba9dc70c"}[chunkId] + ".0.9594175405760539.chunk.js";
};